import React from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
// import FilterListIcon from '@material-ui/icons/FilterList';
import useNotificationDialog from '../../../shared/components/useNotificationDialog';
import { Fragment } from 'react';
import ReactExport  from '@ibrahimrahmani/react-export-excel'
import { Button } from '@material-ui/core';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { useDispatch } from 'react-redux';
import { deleteShippingItem } from '../../../redux/actions/shipping/action';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;




const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.primary.main,
            backgroundColor: lighten(theme.palette.primary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.primary.dark,
          },
    title: {
      flex: '1 1 100%',
    },
  }));


const ShippingDetailToolbar = (props) => {

    const classes = useToolbarStyles();
    const { numSelected, selectedItem, shippingId } = props;
    const {ShowNotificationDialog, handleOpen, open} = useNotificationDialog()
    const dispatch = useDispatch()


    // console.log(selectedItem);
    
    const handleDeleteItem=()=>{
        dispatch(deleteShippingItem({ShippingId : shippingId}))
    }
  
    return (
      <>
         {open && <ShowNotificationDialog  title="Supprimer" action={
             <Fragment>
                  <Button onClick={handleDeleteItem} >supprimer</Button>
             </Fragment>
            } >
  
              {selectedItem.map((_, i)=>{
                  return <Alert severity="error" key={i} > vous ne pouvez supprimer aucun produit </Alert>
              })}
          </ShowNotificationDialog>}
        

         <Toolbar
              className={clsx(classes.root, {
                  [classes.highlight]: numSelected > 0,
                })}
              >

                

              {numSelected > 0 ? (
                  <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
                  {numSelected} selected
                  </Typography>
              ) : (
                  <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                        List des Items
                  </Typography>
              )}
  
              {numSelected > 0 ? (
                  numSelected === 1 && (
                  <>
                      <Tooltip title="editer" placement="top">
                          <IconButton aria-label="delete" color="primary" >
                              <EditIcon />
                          </IconButton>
                      </Tooltip>
                      <div style={{marginLeft:30}}></div>
                      <Tooltip title="supprimer" placement="top">
                          <IconButton aria-label="delete" color="secondary" onClick={handleOpen}>
                                <DeleteIcon />
                          </IconButton>
                      </Tooltip>
                  </>
                  )
              ) :null
            //   (
            //     <Tooltip title="Filter list">
            //     <IconButton aria-label="filter list">
            //         <FilterListIcon />
            //     </IconButton>
            //     </Tooltip>
            // )
          }
          </Toolbar> 

          <ExcelFile element={
              <Button
                variant="outlined"
                style={{borderColor:"#00a152", color:"#00a152", marginTop:10, marginLeft:20, marginBottom:-5}}                  
                size="small"
                className={classes.button}
                startIcon={<DescriptionSharpIcon />}>
                Exporter vers Excell
            </Button> 
          }>

              <ExcelSheet data={selectedItem} name="Shipping">
                    <ExcelColumn label="Code barre" value="ProductBarcode"/>
                    <ExcelColumn label="Nom article" value="ProductName"/>
                    <ExcelColumn label="Qté achat" value="Quantity"/>
                    <ExcelColumn label="Prix achat" value="Price"/>
                    <ExcelColumn label="Prix de vente" value="SellPrice"/>
                    <ExcelColumn label="ProsoftId" value="InternalId"/>
              </ExcelSheet>

          </ExcelFile>
           
      </>
    );
};
  
ShippingDetailToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    selectedItem : PropTypes.array.isRequired,
    setSelected : PropTypes.func.isRequired,
};


export default ShippingDetailToolbar